import { createTheming } from "@callstack/react-theme-provider";
import { themes } from "./themes";

// Initialize theming utilities
const { ThemeProvider, withTheme, useTheme } = createTheming(themes.cyan); // Default theme is X20 teal

// Export the utilities
export { ThemeProvider, withTheme, useTheme };
